import React from 'react';

import { PaymentTrackerProvider } from 'contexts/payment-tracker.context';
import PaymentTrackerContent from './content';

const PaymentTrackerLayout = () => {
  return (
    <PaymentTrackerProvider>
      <PaymentTrackerContent />
    </PaymentTrackerProvider>
  );
};

export default PaymentTrackerLayout;
